import $ from "jquery";
import lottieWeb from 'lottie-web';

lottieWeb.loadAnimation({
    container: document.getElementById('phoneAnimation'),
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/../img/phone.json' // the path to the animation json
});

if(window.innerHeight > window.innerWidth){
    $(".screen--landscape").show();
    $('#phoneAnimation').show();

}else{
    $(".screen--landscape").hide();
    $('#phoneAnimation').hide();

}
$(window).on('resize', e =>{
    if(window.innerHeight > window.innerWidth){
        $(".screen--landscape").show();
        $('#phoneAnimation').show();

    }else{
        $(".screen--landscape").hide();
        $('#phoneAnimation').hide();

    }
});
